import { render } from "./ReferralMailComponent.vue?vue&type=template&id=18c8b0f6"
import script from "./ReferralMailComponent.vue?vue&type=script&lang=js"
export * from "./ReferralMailComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/apps/front/releases/202610291844_919663d2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__